import { getDeployEnv } from "@utils";

export const deployEnvConfig = getDeployEnv();
